import React from 'react'
import { Logo } from '../components/Logo'
import { ComidaNight } from './ComidaNight'
import { PrecioNight } from './PrecioNight'

export const MenuUnificadoNight = () => {
  return (
    <div className="App">
      <Logo></Logo>
      <PrecioNight></PrecioNight>
      <ComidaNight></ComidaNight>
    </div>
  )
}
